module.exports = __webpack_public_path__ + "static/media/profil-img.c96128ee.jpg";